import { graphql } from '~/__gql__';

export const mutationRequestContractExtension = graphql(/* GraphQL */ `
  mutation RequestContractExtension {
    requestContractExtension
  }
`);
